"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synthscape = void 0;
const types_1 = require("../types");
const fizz_1 = require("./fizz");
const hearthHarmony_1 = require("./hearthHarmony");
exports.synthscape = Object.assign(Object.assign({}, fizz_1.fizz), { meta: {
        title: "Synthscape Events",
        description: "Take part of Synthscape-sponsored events in your community!",
        image: (0, types_1.getFileUrl)("/synthscape/tags/logo512.png"),
        icon: (0, types_1.getFileUrl)("/synthscape/tags/favicon.ico"),
    }, company: {
        name: "Synthscape",
        logo: {
            url: (0, types_1.getFileUrl)("/synthscape/logo.svg"),
            description: "synthscape",
            style: {
                height: 25,
                width: "auto",
            },
            versions: {
                white: { url: (0, types_1.getFileUrl)("/synthscape/logo-white.svg") },
            },
        },
    }, event: hearthHarmony_1.hearthHarmony.event, footerLinks: [
        {
            text: "Synthscape Privacy Policy",
            url: "https://www.max.live/privacy-policy",
        },
        { text: "MAX Privacy Policy", url: "https://www.max.live/privacy-policy" },
    ], fanAppUrl: `https://synthscape.live`, artistAppUrl: `https://dashboard.synthscape.live`, regionsCollection: "synthscape_regions" });
